var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import ClaimsButton from '@declaration/components/UI/ClaimsButton.vue';
import RadioImageButton from '@declaration/components/UI/RadioImageButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { FireCauseNeighboorOrigin } from '@shared/types/api/claim';
import { FIRE_CAUSE_NEIGHBOOR_ORIGIN_ANSWERS, FIRE_CAUSE_NEIGHBOOR_ORIGIN_IMAGE_CHOICES, } from '@declaration/constants/fireDamageConstants';
const qualification = namespace('qualification');
const claim = namespace('claim');
let FireCauseNeighboorOriginQuestion = class FireCauseNeighboorOriginQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.typeOfDamages = '';
    }
    get fireCauseNeighboorOriginChoices() {
        return FIRE_CAUSE_NEIGHBOOR_ORIGIN_IMAGE_CHOICES;
    }
    get selectedValue() {
        return this.qualification.fireCauseNeighboorOrigin;
    }
    get validateText() {
        if (this.qualification.fireCauseNeighboorOrigin === FireCauseNeighboorOrigin.dontKnow ||
            this.qualification.fireCauseNeighboorOrigin === null) {
            return this.$tc('claim.damage.fire.button.dont_know');
        }
        return this.$tc('claim.damage.fire.button.next_step');
    }
    get answer() {
        if (this.qualification.fireCauseNeighboorOrigin === FireCauseNeighboorOrigin.Inattention) {
            return this.$tc(FIRE_CAUSE_NEIGHBOOR_ORIGIN_ANSWERS[FireCauseNeighboorOrigin.Inattention]);
        }
        if (this.qualification.fireCauseNeighboorOrigin === FireCauseNeighboorOrigin.ElectricalProblem) {
            return this.$tc(FIRE_CAUSE_NEIGHBOOR_ORIGIN_ANSWERS[FireCauseNeighboorOrigin.ElectricalProblem]);
        }
        if (this.qualification.fireCauseNeighboorOrigin === FireCauseNeighboorOrigin.CriminalAct) {
            return this.$tc(FIRE_CAUSE_NEIGHBOOR_ORIGIN_ANSWERS[FireCauseNeighboorOrigin.CriminalAct]);
        }
        if (this.qualification.fireCauseNeighboorOrigin === FireCauseNeighboorOrigin.HotWorks) {
            return this.$tc(FIRE_CAUSE_NEIGHBOOR_ORIGIN_ANSWERS[FireCauseNeighboorOrigin.HotWorks]);
        }
        if (this.qualification.fireCauseNeighboorOrigin === FireCauseNeighboorOrigin.NaturalOrigin) {
            return this.$tc(FIRE_CAUSE_NEIGHBOOR_ORIGIN_ANSWERS[FireCauseNeighboorOrigin.NaturalOrigin]);
        }
        if (this.qualification.fireCauseNeighboorOrigin === FireCauseNeighboorOrigin.FirePlace) {
            return this.$tc(FIRE_CAUSE_NEIGHBOOR_ORIGIN_ANSWERS[FireCauseNeighboorOrigin.FirePlace]);
        }
        if (this.qualification.fireCauseNeighboorOrigin === FireCauseNeighboorOrigin.Other) {
            return this.$tc(FIRE_CAUSE_NEIGHBOOR_ORIGIN_ANSWERS[FireCauseNeighboorOrigin.Other]);
        }
        if (this.qualification.fireCauseNeighboorOrigin === FireCauseNeighboorOrigin.dontKnow) {
            return this.$tc(FIRE_CAUSE_NEIGHBOOR_ORIGIN_ANSWERS[FireCauseNeighboorOrigin.dontKnow]);
        }
        return null;
    }
    onTypeOfDamagesClick(fireCauseNeighboorOrigin) {
        this.updateFireDamageQualification({
            qualificationPayload: {
                fireCauseNeighboorOrigin: fireCauseNeighboorOrigin !== this.qualification.fireCauseNeighboorOrigin
                    ? fireCauseNeighboorOrigin
                    : null,
            },
        });
    }
    async validate() {
        if (this.qualification.fireCauseNeighboorOrigin === null) {
            await this.updateAndSaveFireDamageQualification({
                qualificationPayload: {
                    fireCauseNeighboorOrigin: FireCauseNeighboorOrigin.dontKnow,
                },
                step: this.step,
            });
        }
        await this.updateAndSaveFireDamageQualification({
            qualificationPayload: {
                fireCauseNeighboorOrigin: this.qualification.fireCauseNeighboorOrigin,
            },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], FireCauseNeighboorOriginQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], FireCauseNeighboorOriginQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], FireCauseNeighboorOriginQuestion.prototype, "updateFireDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], FireCauseNeighboorOriginQuestion.prototype, "updateAndSaveFireDamageQualification", void 0);
FireCauseNeighboorOriginQuestion = __decorate([
    Component({
        components: { RadioImageButton, QuestionPanel, ClaimsButton },
        props: QuestionProps,
    })
], FireCauseNeighboorOriginQuestion);
export default FireCauseNeighboorOriginQuestion;
